import React, { useEffect, useRef, useState, useMemo } from "react";
const HorizontalCarousel = ({ children, interval = 3000 }) => {
  const containerRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const [itemWidth, setItemWidth] = useState(0);
  const slides = React.Children.toArray(children);
  const slideCount = slides.length;
  const displayedSlides = useMemo(() => {
    if (slideCount === 0) return [];
    return slides.concat(slides).concat(slides);
  }, [slides, slideCount]);
  useEffect(() => {
    if (containerRef.current && slideCount > 0) {
      const width = containerRef.current.children[0].offsetWidth;
      setItemWidth(width);
      const init = slideCount * width;
      containerRef.current.scrollTo({ left: init, behavior: "instant" });
    }
  }, [displayedSlides, slideCount]);
  const scrollNext = () => {
    if (!containerRef.current || itemWidth === 0) return;
    containerRef.current.scrollBy({
      left: itemWidth,
      behavior: "smooth",
    });
    setTimeout(() => {
      if (!containerRef.current) return;
      const maxScroll = slideCount * 2 * itemWidth;
      if (containerRef.current.scrollLeft >= maxScroll) {
        containerRef.current.scrollTo({
          left: containerRef.current.scrollLeft - slideCount * itemWidth,
          behavior: "instant",
        });
      }
    }, 300);
  };
  const scrollPrev = () => {
    if (!containerRef.current || itemWidth === 0) return;
    containerRef.current.scrollBy({
      left: -itemWidth,
      behavior: "smooth",
    });
    setTimeout(() => {
      if (!containerRef.current) return;
      const minScroll = slideCount * itemWidth;
      if (containerRef.current.scrollLeft <= minScroll - itemWidth / 2) {
        containerRef.current.scrollTo({
          left: containerRef.current.scrollLeft + slideCount * itemWidth,
          behavior: "instant",
        });
      }
    }, 300);
  };
  useEffect(() => {
    if (paused || itemWidth === 0) return;
    const timer = setInterval(scrollNext, interval);
    return () => clearInterval(timer);
  }, [paused, interval, itemWidth]);
  return (
    <div
      className="relative group"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Prev */}
<button
  onClick={scrollPrev}
  className="
    absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full
    z-[15] cursor-pointer
    text-white bg-blue-500
    w-[65px] h-[65px]
    leading-[50px] text-[15px] text-center
    rounded-full outline-none inline-block
    opacity-0 group-hover:opacity-100 transition
  "
>
  ←
</button>

{/* Next */}
<button
  onClick={scrollNext}
  className="
    absolute right-0 top-1/2 -translate-y-1/2 translate-x-full
    z-[15] cursor-pointer
    text-white bg-blue-500
    w-[65px] h-[65px]
    leading-[50px] text-[15px] text-center
    rounded-full outline-none inline-block
    opacity-0 group-hover:opacity-100 transition
  "
>
  →
</button>

      <div
        ref={containerRef}
        className="flex overflow-x-auto scroll-smooth no-scrollbar"
      >
        {displayedSlides.map((child, index) =>
          React.cloneElement(child, {
            key: `displayed-${index}`,
            onHoverChange: setPaused,
          })
        )}
      </div>
    </div>
  );
};
export default HorizontalCarousel;